var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12051 1.98989C6.58852 1.46313 7.41148 1.46313 7.87949 1.98989L9.62634 3.95603C9.73934 4.08322 9.87858 4.18438 10.0345 4.25254L12.4442 5.30633C13.0898 5.58866 13.3441 6.37133 12.9877 6.97922L11.6576 9.24815C11.5716 9.39492 11.5184 9.5586 11.5017 9.72791L11.2442 12.3453C11.1752 13.0466 10.5094 13.5303 9.82113 13.3792L7.25223 12.8154C7.08605 12.7789 6.91395 12.7789 6.74777 12.8154L4.17887 13.3792C3.49061 13.5303 2.82483 13.0466 2.75583 12.3453L2.49826 9.72791C2.4816 9.5586 2.42841 9.39492 2.34238 9.24815L1.01227 6.97922C0.655913 6.37133 0.910219 5.58866 1.55583 5.30633L3.96554 4.25254C4.12142 4.18438 4.26066 4.08322 4.37366 3.95603L6.12051 1.98989Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03279 1.60573C7.46015 1.0408 6.53985 1.0408 5.96721 1.60573L3.95784 3.58805C3.89478 3.65026 3.82271 3.70262 3.74406 3.74337L1.23784 5.04182C0.523597 5.41186 0.239211 6.28711 0.59954 7.00631L1.86391 9.5299C1.90358 9.60909 1.93111 9.69381 1.94556 9.78121L2.406 12.566C2.53722 13.3596 3.28175 13.9006 4.07709 13.7801L6.86788 13.3575C6.95546 13.3442 7.04454 13.3442 7.13212 13.3575L9.92291 13.7801C10.7183 13.9006 11.4628 13.3596 11.594 12.566L12.0544 9.78121C12.0689 9.69381 12.0964 9.60909 12.1361 9.5299L13.4005 7.00631C13.7608 6.28711 13.4764 5.41186 12.7622 5.04182L10.2559 3.74337C10.1773 3.70262 10.1052 3.65026 10.0422 3.58805L8.03279 1.60573Z",
    fill: "#98A2B3",
    stroke: "#F2F4F7",
    strokeWidth: 0.588235
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_15750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 14,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18784 1.77493C6.64242 1.3412 7.35758 1.3412 7.81216 1.77493L9.88916 3.75674C9.9651 3.8292 10.0504 3.89118 10.1428 3.94101L12.6694 5.30394C13.2224 5.60223 13.4434 6.2824 13.1714 6.84876L11.9284 9.43651C11.8829 9.53113 11.8503 9.6314 11.8315 9.73466L11.3161 12.5588C11.2032 13.1769 10.6247 13.5973 10.002 13.5136L7.15674 13.1311C7.05272 13.1171 6.94728 13.1171 6.84326 13.1311L3.99805 13.5136C3.37534 13.5973 2.79676 13.1769 2.68395 12.5588L2.1685 9.73466C2.14965 9.6314 2.11707 9.53113 2.07162 9.43651L0.82864 6.84875C0.556601 6.2824 0.7776 5.60223 1.33058 5.30394L3.85722 3.94101C3.9496 3.89118 4.0349 3.8292 4.11084 3.75674L6.18784 1.77493Z",
    fill: "#D0D5DD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_15750)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1293_15750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2917 8.58333L-3.5 8.58333L-2.04167 16.4583L6.125 24.625L14.2917 16.4583L14.2917 8.58333Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99919 6.25C6.03222 6.25 5.24635 7.03147 5.24797 7.99663C5.24797 8.96178 6.03222 9.74326 6.99919 9.74326C7.96617 9.74326 8.75203 8.96178 8.75203 7.99663C8.75203 7.03147 7.96778 6.25 6.99919 6.25ZM6.99919 10.2089C6.74532 10.2105 6.46558 10.188 6.15026 10.13C5.52609 10.014 5.15095 9.68847 4.39418 9.83671C2.72866 10.1638 1.29922 14.9332 3.33827 14.9993C4.42976 15.0347 5.09435 13.8021 5.91903 13.4782C6.14056 13.3912 6.58038 13.3493 6.99919 13.3477C7.41961 13.3493 7.85783 13.3912 8.08097 13.4782C8.90565 13.8021 9.57024 15.0347 10.6617 14.9993C12.7008 14.9332 11.2713 10.1638 9.60582 9.83671C8.84905 9.68686 8.47229 10.0123 7.84974 10.13C7.53442 10.188 7.25468 10.2105 6.99919 10.2089Z",
    fill: "url(#paint0_linear_1293_15750)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1293_15750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6458 6.58542L10.7323 6.51616L10.7863 6.25L10.8281 6.50521L10.9375 6.54167L10.8281 6.61458L10.7863 6.83333L10.7552 6.61458L10.6458 6.58542Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1293_15750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 5.17083L9.50617 5.03231L9.6142 4.5L9.69792 5.01042L9.91667 5.08333L9.69792 5.22917L9.6142 5.66667L9.55208 5.22917L9.33333 5.17083Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_1293_15750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 5.37516L5.25 0.41683L7.58333 -1.9165L17.7917 3.04183L16.3333 8.00016L9.91667 5.37516Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1293_15750",
    x: -5.85294,
    y: 6.23031,
    width: 22.4975,
    height: 20.7476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17647,
    result: "effect1_foregroundBlur_1293_15750"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1293_15750",
    x: 10.587,
    y: 6.19118,
    width: 0.409315,
    height: 0.700899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0294118,
    result: "effect1_foregroundBlur_1293_15750"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1293_15750",
    x: 9.27451,
    y: 4.44118,
    width: 0.700981,
    height: 1.2844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0294118,
    result: "effect1_foregroundBlur_1293_15750"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1293_15750",
    x: 2.89706,
    y: -4.26945,
    width: 17.2476,
    height: 14.6226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17647,
    result: "effect1_foregroundBlur_1293_15750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1293_15750",
    x1: 7,
    y1: 6.25,
    x2: 7,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455074,
    stopColor: "white",
    stopOpacity: 0.561695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoints);
export default __webpack_public_path__ + "static/media/icon-points.90a7e89af947c6df0dbf758440d25803a3ea2c216cff315f0b352cd7a297ca5d.svg";
export { ForwardRef as ReactComponent };